module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "fullscreen": _vm.isMovil,
      "hide-overlay": _vm.isMovil,
      "transition": "dialog-bottom-transition",
      "width": _vm.isMovil ? '100%' : '500'
    },
    model: {
      value: (_vm.showInfoUser),
      callback: function($$v) {
        _vm.showInfoUser = $$v
      },
      expression: "showInfoUser"
    }
  }, [_c('item-usuario', {
    attrs: {
      "is-fetch": "is-fetch",
      "username": _vm.ticket.usuario,
      "show-details": "show-details"
    }
  })], 1), _c('v-dialog', {
    attrs: {
      "max-width": _vm.isMovil ? '100%' : '60%',
      "transition": "dialog-bottom-transition",
      "fullscreen": _vm.isMovil
    },
    model: {
      value: (_vm.isUploadFiles),
      callback: function($$v) {
        _vm.isUploadFiles = $$v
      },
      expression: "isUploadFiles"
    }
  }, [_c('v-card', [(_vm.isUploadFiles) ? _c('adjuntar-archivos', {
    ref: "archivos-nota-credito",
    attrs: {
      "multiple": false,
      "extensions": ['pdf', 'jpg', 'png', 'jpeg']
    },
    on: {
      "close": _vm.closeModalAdjuntar,
      "save": _vm.setFilesToSave
    }
  }) : _vm._e()], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500",
      "min-height": "500"
    },
    model: {
      value: (_vm.isModalIntegracion),
      callback: function($$v) {
        _vm.isModalIntegracion = $$v
      },
      expression: "isModalIntegracion"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "px-2 pt-2 text-center flex d-flex fd-column ai-center"
  }, [_c('div', {
    staticClass: "text-center font-weight-700 font-size-18"
  }, [_vm._v("GENERAR INFORME TECNICO - " + _vm._s(_vm.ticket.serie))]), (!_vm.isLoadingGetSerie && _vm.datosSerieInforme && !_vm.datosSerieInforme.clienteSinDeudas) ? _c('div', {
    staticClass: "text-center flex d-flex jc-center banner-ok"
  }, [_vm._v("CLIENTE SIN DEUDA")]) : _vm._e(), (!_vm.isLoadingGetSerie && _vm.datosSerieInforme && _vm.datosSerieInforme.clienteSinDeudas) ? _c('div', {
    staticClass: "text-center flex d-flex jc-center banner-deuda"
  }, [_vm._v("CLIENTE CON DEUDA")]) : _vm._e()]), (_vm.isLoadingGetSerie) ? _c('v-card-text', [_c('span', [_vm._v("Cargando ...")])]) : _c('v-card-text', [_c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.tiposInformeFiltrado,
      "item-text": "name",
      "item-value": "code",
      "label": "Tipo",
      "dense": "",
      "hide-details": "hide-details",
      "disabled": _vm.isGenerarITGarantia
    },
    model: {
      value: (_vm.tipoIntegracion),
      callback: function($$v) {
        _vm.tipoIntegracion = $$v
      },
      expression: "tipoIntegracion"
    }
  })], 1)], 1), (!_vm.isGenerarITGarantia) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-autocomplete', {
    staticClass: "mt-1",
    attrs: {
      "loading": _vm.isGettingFallas,
      "dense": "dense",
      "hide-details": "hide-details",
      "item-text": "descripcionFallaGeneral",
      "item-value": "codigoFallaGeneral",
      "return-object": "return-object",
      "items": _vm.fallas,
      "placeholder": "Falla"
    },
    model: {
      value: (_vm.fallaSeleccionada),
      callback: function($$v) {
        _vm.fallaSeleccionada = $$v
      },
      expression: "fallaSeleccionada"
    }
  })], 1)], 1) : _vm._e(), (!_vm.isGenerarITGarantia) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [(_vm.isModalIntegracion) ? _c('listado-direcciones-seleccionar', {
    attrs: {
      "codigo": _vm.datosSerieInforme.codigoClienteSap,
      "id": _vm.direccionSeleccionado.id
    },
    on: {
      "selected": _vm.getDireccion
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), (!_vm.isGenerarITGarantia) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-autocomplete', {
    staticClass: "mt-1",
    attrs: {
      "loading": _vm.isLoadingUbigeos,
      "dense": "dense",
      "hide-details": "hide-details",
      "item-text": "descripcion",
      "item-value": "ubigeo",
      "return-object": "return-object",
      "items": _vm.ubigeos,
      "placeholder": "Ubigeo"
    },
    model: {
      value: (_vm.ubigeoSeleccionado),
      callback: function($$v) {
        _vm.ubigeoSeleccionado = $$v
      },
      expression: "ubigeoSeleccionado"
    }
  })], 1)], 1) : _vm._e(), (!_vm.isGenerarITGarantia) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Ubicacion equipo *",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.datosSerieInforme.extra),
      callback: function($$v) {
        _vm.$set(_vm.datosSerieInforme, "extra", $$v)
      },
      expression: "datosSerieInforme.extra"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Telefono contacto *",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.datosSerieInforme.telefono),
      callback: function($$v) {
        _vm.$set(_vm.datosSerieInforme, "telefono", $$v)
      },
      expression: "datosSerieInforme.telefono"
    }
  })], 1)], 1) : _vm._e(), (!_vm.isGenerarITGarantia) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Email contacto*",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.datosSerieInforme.email),
      callback: function($$v) {
        _vm.$set(_vm.datosSerieInforme, "email", $$v)
      },
      expression: "datosSerieInforme.email"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Nombre contacto *",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.datosSerieInforme.contacto),
      callback: function($$v) {
        _vm.$set(_vm.datosSerieInforme, "contacto", $$v)
      },
      expression: "datosSerieInforme.contacto"
    }
  })], 1)], 1) : _vm._e(), (!_vm.isGenerarITGarantia) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Observacion para el informe*",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.datosSerieInforme.observacion),
      callback: function($$v) {
        _vm.$set(_vm.datosSerieInforme, "observacion", $$v)
      },
      expression: "datosSerieInforme.observacion"
    }
  })], 1)], 1) : _vm._e()], 1), _c('v-card-actions', [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "primary",
      "block": "block"
    },
    on: {
      "click": function($event) {
        return _vm.fetchIntegrarTicket()
      }
    }
  }, [_c('small', [_vm._v("Continuar")])])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "350",
      "min-height": "350"
    },
    model: {
      value: (_vm.isModalAsignacionZona),
      callback: function($$v) {
        _vm.isModalAsignacionZona = $$v
      },
      expression: "isModalAsignacionZona"
    }
  }, [_c('v-card', {
    staticClass: "pa-6"
  }, [_c('div', {
    staticClass: "px-4 py-3"
  }, [_c('div', {
    staticClass: "text-center font-weight-700 font-size-18"
  }, [_vm._v("Actualiza el area y zona de garantia")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "font-weight-700 font-size-13"
  }, [_vm._v("Area")]), (_vm.ticket.numero) ? _c('v-radio-group', {
    staticClass: "py-0 mb-6 mt-2",
    attrs: {
      "column": "column",
      "hide-details": "hide-details",
      "disabled": _vm.isLoadingChangeTipoArea || _vm.perfil === 'supervisor'
    },
    on: {
      "change": function($event) {
        return _vm.fetchActualizarTipoArea()
      }
    },
    model: {
      value: (_vm.ticket.tipoArea),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "tipoArea", $$v)
      },
      expression: "ticket.tipoArea"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "campo"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.ticket.tipoArea === 'campo'
          }
        }, [_vm._v("Campo")])]
      },
      proxy: true
    }], null, false, 1258975406)
  }), _c('v-radio', {
    attrs: {
      "value": "taller"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.ticket.tipoArea === 'taller'
          }
        }, [_vm._v("Taller")])]
      },
      proxy: true
    }], null, false, 2907251278)
  }), _c('v-radio', {
    attrs: {
      "value": "sin asignacion"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.ticket.tipoArea === 'sin asignacion'
          }
        }, [_vm._v("Sin asignación")])]
      },
      proxy: true
    }], null, false, 3030543634)
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "font-weight-700 font-size-13"
  }, [_vm._v("Zona")]), (_vm.ticket.numero) ? _c('v-radio-group', {
    staticClass: "py-0 mt-2",
    attrs: {
      "column": "column",
      "hide-details": "hide-details",
      "disabled": _vm.isLoadingChangeZonaGarantia || _vm.perfil === 'supervisor'
    },
    on: {
      "change": function($event) {
        return _vm.fetchActualizaZonaGarantia()
      }
    },
    model: {
      value: (_vm.ticket.zonaGarantia),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "zonaGarantia", $$v)
      },
      expression: "ticket.zonaGarantia"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "lima"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.ticket.zonaGarantia === 'lima'
          }
        }, [_vm._v("Lima")])]
      },
      proxy: true
    }], null, false, 416770790)
  }), _c('v-radio', {
    attrs: {
      "value": "arequipa"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.ticket.zonaGarantia === 'arequipa'
          }
        }, [_vm._v("Arequipa")])]
      },
      proxy: true
    }], null, false, 3209553030)
  }), _c('v-radio', {
    attrs: {
      "value": "sin asignacion"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.ticket.zonaGarantia === 'sin asignacion'
          }
        }, [_vm._v("Sin asignación")])]
      },
      proxy: true
    }], null, false, 831268698)
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex mt-8"
  }, [_c('p', {
    staticClass: "font-size-11 text-muted my-2 mb-0"
  }, [_vm._v("Al realizar el cambio de area y zona se le notificará a los dispatcher que pertenezcan a la zona que selecciones.")])])])])])], 1), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": _vm.isMovil ? '100%' : '450',
      "fullscreen": _vm.isMovil,
      "hide-overlay": _vm.isMovil
    },
    model: {
      value: (_vm.isModalEditarCita),
      callback: function($$v) {
        _vm.isModalEditarCita = $$v
      },
      expression: "isModalEditarCita"
    }
  }, [(_vm.isModalEditarCita) ? _c('form-cita', {
    attrs: {
      "id": _vm.ticket.idCita,
      "is-creacion-externo": !_vm.isCreacionExterno,
      "no-esta-en-agenda": "no-esta-en-agenda",
      "numero-ticket": _vm.ticket.numero
    },
    on: {
      "close": function($event) {
        return _vm.closeModalEditarCita()
      },
      "update": function($event) {
        _vm.fetch();
        _vm.$refs.activity.fetchActividades(true)
      }
    }
  }) : _vm._e()], 1), (_vm.isMovil) ? _c('v-tabs', {
    staticClass: "elevation-1 position-sticky",
    attrs: {
      "fixed-tabs": ""
    }
  }, [_c('v-tab', {
    on: {
      "click": function($event) {
        _vm.tabActive = 1
      }
    }
  }, [_c('small', [_vm._v("detalles")])]), _c('v-tab', {
    on: {
      "click": function($event) {
        _vm.tabActive = 2
      }
    }
  }, [_c('small', [_vm._v("actividades")])]), (_vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario-contrato' && _vm.ticket.abierto) ? _c('v-tab', {
    on: {
      "click": function($event) {
        _vm.tabActive = 3
      }
    }
  }, [_c('small', [_vm._v("acciones")])]) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "pa-3"
  }, [_c('v-dialog', {
    attrs: {
      "width": "450",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalAddMessage()
      }
    },
    model: {
      value: (_vm.isAddMessageChanges),
      callback: function($$v) {
        _vm.isAddMessageChanges = $$v
      },
      expression: "isAddMessageChanges"
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-18 py-2"
  }, [_vm._v("¿Deseas agregar algún comentario para los cambios que se van a realizar?")]), _c('div', {
    staticClass: "pa-4"
  }, [_c('v-textarea', {
    ref: "comentarioChanges",
    attrs: {
      "hide-details": "hide-details",
      "autofocus": "autofocus",
      "placeholder": "Describe (opcional)",
      "color": "primary",
      "solo": "solo",
      "dense": "dense",
      "rows": "6"
    },
    model: {
      value: (_vm.comentarioChanges),
      callback: function($$v) {
        _vm.comentarioChanges = $$v
      },
      expression: "comentarioChanges"
    }
  })], 1), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "success",
      "block": "block",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchActualizarDatosTicket()
      }
    }
  }, [_vm._v("Confirmar los cambios")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "450",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalAnular()
      }
    },
    model: {
      value: (_vm.isModalAnularTicket),
      callback: function($$v) {
        _vm.isModalAnularTicket = $$v
      },
      expression: "isModalAnularTicket"
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-18 py-2"
  }, [_vm._v("¿Estas seguro que deseas anular el ticket?")]), _c('div', {
    staticClass: "pa-4"
  }, [_c('v-textarea', {
    ref: "comentarioParaAnular",
    attrs: {
      "hide-details": "hide-details",
      "autofocus": "autofocus",
      "placeholder": "Describe un motivo por el cual deseas anular el ticket",
      "color": "primary",
      "solo": "solo",
      "dense": "dense",
      "rows": "6"
    },
    model: {
      value: (_vm.comentarioParaAnular),
      callback: function($$v) {
        _vm.comentarioParaAnular = $$v
      },
      expression: "comentarioParaAnular"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.closeModalAnular()
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": _vm.isMovil,
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchCloseTicket()
      }
    }
  }, [_vm._v("Anular ticket")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.isMovil,
      "hide-overlay": _vm.isMovil,
      "transition": "dialog-bottom-transition",
      "width": _vm.isMovil ? '100%' : '500'
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalDataSerie()
      }
    },
    model: {
      value: (_vm.showModalDataSerie),
      callback: function($$v) {
        _vm.showModalDataSerie = $$v
      },
      expression: "showModalDataSerie"
    }
  }, [(_vm.showModalDataSerie) ? _c('v-card', [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('item-serie', {
    attrs: {
      "serie": _vm.ticket.serie,
      "tipo-ticket": _vm.ticket.tipoticket
    },
    on: {
      "close": function($event) {
        return _vm.closeModalDataSerie()
      }
    }
  })], 1)], 1) : _vm._e()], 1), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.isMovil,
      "hide-overlay": _vm.isMovil,
      "transition": "dialog-bottom-transition",
      "width": _vm.isMovil ? '100%' : '500'
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalFacturasAsociadas()
      }
    },
    model: {
      value: (_vm.showModalFacturasAsociadas),
      callback: function($$v) {
        _vm.showModalFacturasAsociadas = $$v
      },
      expression: "showModalFacturasAsociadas"
    }
  }, [(_vm.showModalFacturasAsociadas) ? _c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('div', {
    staticClass: "flex fd-column py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('h2', [_c('strong', [_vm._v(" Facturas asociadas a la serie " + _vm._s(_vm.ticket.serie))])]), _c('v-radio-group', {
    staticClass: "py-0 mt-4",
    attrs: {
      "row": "row",
      "hide-details": "hide-details",
      "disabled": _vm.isLoadingFacturasAsociados
    },
    on: {
      "change": function($event) {
        return _vm.fetchFacturasAsociadas()
      }
    },
    model: {
      value: (_vm.empresaFacturasAsociadas),
      callback: function($$v) {
        _vm.empresaFacturasAsociadas = $$v
      },
      expression: "empresaFacturasAsociadas"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "datacont"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.empresaFacturasAsociadas === 'datacont'
          }
        }, [_vm._v("Datacont")])]
      },
      proxy: true
    }], null, false, 2050514825)
  }), _c('v-radio', {
    attrs: {
      "value": "reprodata"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.empresaFacturasAsociadas === 'reprodata'
          }
        }, [_vm._v("Reprodata")])]
      },
      proxy: true
    }], null, false, 3256102249)
  })], 1)], 1), (_vm.isLoadingFacturasAsociados) ? _c('div', {
    staticClass: "flex pa-4 ai-center jc-center"
  }, [_c('v-progress-circular', {
    staticClass: "indeterminate",
    attrs: {
      "color": "primary"
    }
  })], 1) : _vm._l((_vm.dataFacturasAsociadas), function(factura, index) {
    return _c('v-card', {
      key: index,
      staticClass: "px-4 py-3 mt-4"
    }, [_c('div', {
      staticClass: "flex fd-column"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('h4', {
      staticClass: "primary--text font-weight-700"
    }, [_vm._v(_vm._s(factura.FolioPrefFactura) + " - " + _vm._s(factura.FolioNumFactura))]), _c('v-spacer'), _c('v-chip', {
      staticClass: "font-size-11 bold"
    }, [_vm._v(" " + _vm._s(factura.fechaFactura))])], 1), _c('strong', {
      staticClass: "font-size-11"
    }, [_vm._v(" " + _vm._s(factura.nombreCliente))])]), _c('div', {
      staticClass: "flex fd-column"
    }, [_c('span', {
      staticClass: "font-size-11"
    }, [_vm._v(" " + _vm._s(factura.codigoArticulo) + " - " + _vm._s(factura.descripcionArticulo))])]), (factura.pdfFactura) ? _c('div', {
      staticClass: "flex fd-column"
    }, [_c('v-btn', {
      staticClass: "flex-uno mt-2 width-full",
      attrs: {
        "color": "primary",
        "block": _vm.isMovil,
        "small": !_vm.isMovil
      },
      on: {
        "click": function($event) {
          return _vm.goToPdfFacturaAsociada(factura.pdfFactura)
        }
      }
    }, [_vm._v("Ver PDF de la factura")])], 1) : _vm._e()])
  }), (!_vm.isLoadingFacturasAsociados && !_vm.dataFacturasAsociadas.length) ? _c('div', {
    staticClass: "flex py-4 ai-center jc-center"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("No existen facturas asociadas para esta serie")])]) : _vm._e()], 2)], 1) : _vm._e()], 1), _c('v-row', [(!_vm.isMovil || _vm.isMovil && _vm.tabActive === 1) ? _c('v-col', {
    attrs: {
      "md": _vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario' && _vm.ticket.abierto ? '3' : '4'
    }
  }, [(_vm.ticket.numero && (_vm.perfil === 'usuario-contrato' || _vm.perfil === 'usuario') && _vm.ticket.abierto) ? _c('div', {
    staticClass: "flex-1 mb-4"
  }, [_c('v-btn', {
    staticClass: "width-full",
    attrs: {
      "color": "primary",
      "disabled": _vm.ticket.estado >= 13 && _vm.ticket.tipoticket === 'garantia',
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        _vm.isModalAnularTicket = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v(" block")]), _vm._v("Anular ticket")], 1), (_vm.ticket.estado >= 13 && _vm.ticket.tipoticket === 'garantia') ? _c('strong', {
    staticClass: "font-size-11"
  }, [_vm._v("No se puede anular el ticket por que el equipo ya ingreso al taller")]) : _vm._e()], 1) : _vm._e(), (_vm.ticket.numero && !_vm.ticket.abierto) ? _c('v-alert', {
    attrs: {
      "icon": "error",
      "outlined": "outlined",
      "text": "",
      "dense": "dense",
      "type": "error"
    }
  }, [_c('span', {
    staticClass: "font-size-15 font-weight-700"
  }, [_vm._v("El ticket se encuentra cerrado")]), _c('div', {
    staticClass: "d-flex"
  }, [_c('small', {
    staticClass: "font-weight-700"
  }, [_vm._v("fecha de cierre " + _vm._s(_vm._f("formatoFecha")(_vm.ticket.fechaQueSeCerro)))])])]) : _vm._e(), _c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [(_vm.ticket.usuario && _vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario-contrato') ? _c('v-expansion-panel', {
    key: "usuario"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [_c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("perm_identity")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Información del usuario")])], 1)])]), _c('v-expansion-panel-content', [_c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    domProps: {
      "textContent": _vm._s(_vm.ticket.razonSocial)
    }
  }), _c('v-list-item-subtitle', {
    domProps: {
      "textContent": _vm._s(_vm.ticket.usuario)
    }
  })], 1)], 1), _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        _vm.showInfoUser = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v(" visibility")]), _vm._v("mas Información")], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), (_vm.ticket.idCita) ? _c('v-expansion-panel', {
    key: "cita_programada"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("date_range")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Información de la cita")])], 1)])], 1), _c('v-expansion-panel-content', [_c('v-card', {
    key: "ticketSeleccionada",
    staticClass: "elevation-0"
  }, [_c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-title', [_c('span', {
    staticClass: "font-weight-700 font-size-14 primary--text"
  }, [_vm._v(_vm._s(_vm.datosCita.fechaCita) + " " + _vm._s(_vm.datosCita.horaCita))])]), _c('v-list-item-subtitle', {
    staticClass: "grey--text font-size-11"
  }, [_vm._v("Fué programado  " + _vm._s(_vm._f("now")(_vm.datosCita.fechaRegistro)))])], 1), _c('v-list-item-action', [(_vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario-contrato') ? _c('v-btn', {
    attrs: {
      "color": "success",
      "fab": "fab",
      "small": "small",
      "disabled": _vm.perfil === 'supervisor'
    },
    on: {
      "click": function($event) {
        _vm.isModalEditarCita = true
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), (_vm.ticket.codigoTecnico && _vm.ticket.tipoticket !== 'contrato') ? _c('v-expansion-panel', {
    key: "permisos_tecnico"
  }) : _vm._e(), _c('v-expansion-panel', {
    key: "ticket"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("info_outline")]), _c('strong', {
    staticClass: "font-size-12 font-weight-700"
  }, [_vm._v("Información del ticket")]), _c('small', {
    staticClass: "text-muted font-size-11 ml-2"
  }, [_vm._v("(se registró " + _vm._s(_vm._f("now")(_vm.ticket.fechaRegistro)) + ")")])], 1)], 1), _c('v-expansion-panel-content', [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "card"
    }
  }) : _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', [_c('h2', {
    staticClass: "primary--text font-weight-700"
  }, [_vm._v(_vm._s(("#" + (_vm.ticket.numero))))]), _c('v-list-item-title', {
    staticClass: "font-weight-700"
  }, [_c('strong', {
    staticClass: "font-size-11"
  }, [_vm._v("   " + _vm._s(_vm.ticket.tipoticket ? _vm.ticket.tipoticket.toUpperCase() : ''))])])], 1)], 1), (_vm.perfil !== 'usuario' && _vm.perfil !== 'usuario-contrato') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Numero informe tecnico")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.numeroInformeTecnico
    }
  }, [_vm._v(_vm._s(_vm.ticket.numeroInformeTecnico ? _vm.ticket.numeroInformeTecnico : '--'))])], 1)], 1) : _vm._e(), (_vm.perfil !== 'usuario' && _vm.perfil !== 'usuario-contrato' && _vm.ticket.tipoticket === 'garantia') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Numero solicitud orden de compra")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.numeroSolicitudOrdenCompra
    }
  }, [_vm._v(_vm._s(_vm.ticket.numeroSolicitudOrdenCompra ? _vm.ticket.numeroSolicitudOrdenCompra : '--'))])], 1)], 1) : _vm._e(), (_vm.perfil !== 'usuario' && _vm.perfil !== 'usuario-contrato' && _vm.ticket.tipoticket === 'garantia') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Numero solicitud parte de ingreso")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.numeroParteIngreso
    }
  }, [_vm._v(_vm._s(_vm.ticket.numeroParteIngreso ? _vm.ticket.numeroParteIngreso : '--'))])], 1)], 1) : _vm._e(), (_vm.ticket.tipoticket === 'solicitud de insumo') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Insumos solicitados")]), _c('div', {
    staticClass: "d-flex fd-column"
  }, _vm._l((_vm.ticket.insumo), function(insumo, index) {
    return _c('strong', {
      key: index,
      staticClass: "font-size-12"
    }, [_vm._v("- " + _vm._s(insumo))])
  }), 0)], 1)], 1) : _vm._e(), (_vm.ticket.tipoticket === 'solicitud de insumo') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Dirección de entrega")]), _c('v-list-item-title', [_c('span', [_vm._v(_vm._s(_vm.ticket.direccion) + " - (" + _vm._s(_vm.ticket.departamento) + "/" + _vm._s(_vm.ticket.provincia) + "/" + _vm._s(_vm.ticket.distrito) + ")")])])], 1)], 1) : _vm._e(), (_vm.ticket.tipoticket === 'solicitud de insumo') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Nombre contacto")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.nombreContacto
    }
  }, [_vm._v(_vm._s(_vm.ticket.nombreContacto ? _vm.ticket.nombreContacto : '--'))])], 1)], 1) : _vm._e(), (_vm.ticket.tipoticket === 'solicitud de insumo') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Telefono contacto")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.numeroTelefono
    }
  }, [_vm._v(_vm._s(_vm.ticket.numeroTelefono ? _vm.ticket.numeroTelefono : '--'))])], 1)], 1) : _vm._e(), (_vm.ticket.tipoticket === 'solicitud de insumo') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Ultimo contador")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.contadorActual
    }
  }, [_vm._v(_vm._s(_vm.ticket.contadorActual ? _vm.ticket.contadorActual : '--'))])], 1)], 1) : _vm._e(), _c('v-divider'), _c('div', {
    staticClass: "d-flex fd-column mt-2"
  }, [_c('span', {
    staticClass: "font-size-12 gray--text font-weight-700"
  }, [_vm._v("Descripción de la falla")]), (_vm.ticket.descripcionFalla) ? _c('v-alert', {
    staticClass: "my-1 word-break-message",
    attrs: {
      "icon": "handyman",
      "text": "",
      "dense": "dense",
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('span', {
    staticClass: "font-size-14 font-weight-700"
  }, [_vm._v(_vm._s(_vm.ticket.descripcionFalla))]), _c('span', {
    staticClass: "font-size-11 font-italic pt-2"
  }, [_vm._v("\"" + _vm._s(_vm.ticket.comentarioFalla) + "\"")])])]) : _c('span', {
    staticClass: "font-weight-700 font-size-12",
    class: {
      'error--text': !_vm.ticket.comentarioFalla
    }
  }, [_vm._v("No se especificado")])], 1), _c('div', {
    staticClass: "d-flex fd-column mt-2"
  }, [_c('span', {
    staticClass: "font-size-12 gray--text font-weight-700"
  }, [_vm._v("Comentario general")]), (_vm.ticket.comentarioGeneral) ? _c('v-alert', {
    staticClass: "my-1 word-break-message",
    attrs: {
      "icon": "mark_chat_unread",
      "text": "",
      "type": "info"
    }
  }, [_c('span', {
    staticClass: "font-size-11 font-italic"
  }, [_vm._v("\"" + _vm._s(_vm.ticket.comentarioGeneral) + "\"")])]) : _c('span', {
    staticClass: "font-weight-700 font-size-12",
    class: {
      'error--text': !_vm.ticket.comentarioGeneral
    }
  }, [_vm._v("No se especificado")])], 1), _c('div', {
    staticClass: "d-flex fd-column mt-2"
  }, [_c('span', {
    staticClass: "font-size-12 gray--text font-weight-700"
  }, [_vm._v("Estado actual del ticket")]), _c('span', {
    staticClass: "font-weight-700 font-size-12 primary--text text-uppercase"
  }, [_vm._v(_vm._s(_vm.ticket.descripcionEstado))])]), (_vm.ticket.numeroInformeTecnico && _vm.ticket.urlGuiaRecepcionFirmada) ? _c('v-list-item', {
    staticClass: "px-0",
    on: {
      "click": function($event) {
        return _vm.openInformeDeRecepcion()
      }
    }
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Informe de recepción")]), _c('v-list-item-title', {
    staticClass: "font-weight-700"
  }, [_c('v-btn', {
    staticClass: "animated fadeInUp faster",
    attrs: {
      "small": "small",
      "block": "block",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.openInformeDeRecepcion()
      }
    }
  }, [_c('v-icon', [_vm._v(" visibility")]), _vm._v("   Visualizar")], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _c('v-expansion-panel', {
    key: "equipo"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("category")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Información del equipo")])], 1)])], 1), _c('v-expansion-panel-content', [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar-two-line"
    }
  }) : _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [(_vm.ticket.marca) ? _c('v-list-item', [_c('v-img', {
    attrs: {
      "src": (_vm.apiUpload + "/upload/octopus/marcas/" + (_vm.ticket.marca) + ".jpg"),
      "width": "70",
      "height": "70",
      "contain": "contain"
    }
  })], 1) : _vm._e(), _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Marca")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.marca
    }
  }, [_vm._v(_vm._s(_vm.ticket.marca ? _vm.ticket.marca : '--'))])], 1)], 1), (_vm.ticket.numero) ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Serie")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.serie
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('span', {
    staticClass: "mb-2"
  }, [_vm._v(_vm._s(_vm.ticket.serie ? _vm.ticket.serie : '--'))]), (_vm.seriesRepetidas.length > 0) ? _c('v-select', {
    attrs: {
      "dense": "dense",
      "items": _vm.seriesRepetidas,
      "label": "Series en tickes repetidos",
      "item-text": "numero",
      "item-value": "id"
    },
    on: {
      "change": _vm.goTicket
    },
    model: {
      value: (_vm.ticket.numeroTicketRepetido),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "numeroTicketRepetido", $$v)
      },
      expression: "ticket.numeroTicketRepetido"
    }
  }) : _vm._e(), (_vm.perfil !== 'usuario' && _vm.perfil !== 'usuario-contrato' && _vm.ticket.serie) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "info",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.goToHistoriaTecnica()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "size": "14"
    }
  }, [_vm._v(" link")]), _c('small', [_vm._v("Historia tecnica")])], 1) : _vm._e(), (_vm.ticket.tipoticket === 'garantia' && _vm.ticket.serie) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "primary",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.openModalFacturasAsociadas()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "size": "14"
    }
  }, [_vm._v(" link")]), _c('small', [_vm._v("Facturas asociadas")])], 1) : _vm._e()], 1)])], 1)], 1) : _vm._e(), _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Descripcion equipo")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.descripcion
    }
  }, [_vm._v(_vm._s(_vm.ticket.descripcion ? _vm.ticket.descripcion : '--'))])], 1)], 1), _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Codigo equipo")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.codigoArticulo
    }
  }, [_vm._v(_vm._s(_vm.ticket.codigoArticulo ? _vm.ticket.codigoArticulo : '--'))])], 1)], 1), _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Modelo equipo")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.modelo
    }
  }, [_vm._v(_vm._s(_vm.ticket.modelo ? _vm.ticket.modelo : '--'))])], 1)], 1), (_vm.ticket.tipoticket === 'garantia') ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v("Factura electronica")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.ticket.factura
    }
  }, [_vm._v(_vm._s(_vm.ticket.factura ? _vm.ticket.factura : 'No asignado'))])], 1)], 1) : _vm._e(), (_vm.ticket.ubigeo) ? _c('v-divider') : _vm._e(), (_vm.ticket.ubigeo) ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    staticClass: "background"
  }, [_vm._v("location_on")])], 1), _c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.ticket.direccion))]), _c('v-list-item-subtitle', {
    staticClass: "font-size-12 font-weight-700"
  }, [_vm._v("(" + _vm._s(_vm.ticket.ubigeo) + ") / " + _vm._s(_vm.ticket.departamento) + " - " + _vm._s(_vm.ticket.provincia) + " - " + _vm._s(_vm.ticket.distrito))])], 1)], 1) : _vm._e()], 1)], 1)], 1), (_vm.ticket.tipoticket !== 'garantia') ? _c('v-expansion-panel', {
    key: "contrato"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("receipt_long")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Información del contrato")]), _c('span', {
    staticClass: "font-size-12 info--text ml-2"
  }, [_vm._v("# " + _vm._s(_vm.datosContrato.numeroContrato))])], 1)])], 1), _c('v-expansion-panel-content', [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar-two-line"
    }
  }) : _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Empresa")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.datosContrato.empresa
    }
  }, [_vm._v(_vm._s(_vm.datosContrato.empresa ? _vm.datosContrato.empresa : '--'))])], 1)], 1), (_vm.ticket.numero) ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Tipo")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.datosContrato.descripcionTipoContrato
    }
  }, [_vm._v(_vm._s(_vm.datosContrato.descripcionTipoContrato ? _vm.datosContrato.descripcionTipoContrato : '--'))])], 1)], 1) : _vm._e(), _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" Vigencia")]), _c('v-list-item-title', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm._f("formatoFecha")(_vm.datosContrato.fechaDesde)) + " - " + _vm._s(_vm._f("formatoFecha")(_vm.datosContrato.fechaHasta)))])], 1)], 1), _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-subtitle', [_vm._v(" ¿Incluye papel?")]), _c('v-list-item-title', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm.datosContrato.incluyePapel ? 'Si incluye' : 'No incluye'))])], 1)], 1)], 1)], 1)], 1) : _vm._e(), (_vm.ticket.codigoTecnico && _vm.perfil === 'usuario-contrato') ? _c('v-expansion-panel', {
    key: "tecnico"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [_c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("perm_identity")]), _c('small', [_vm._v("Tecnico asignado para su atención")])], 1)])]), _c('v-expansion-panel-content', [_c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    staticClass: "background"
  }, [_vm._v("perm_identity")])], 1), _c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-title', {
    staticClass: "uppercase bold is-bold"
  }, [_c('strong', [_vm._v(_vm._s(_vm.ticket.nombreTecnico))])]), _c('v-list-item-subtitle', {
    staticClass: "font-size-12 font-weight-700"
  }, [_vm._v("Tecnico de campo")])], 1)], 1), (_vm.datosTecnico) ? _c('v-list-item', {
    staticClass: "px-0"
  }, [_c('v-list-item-content', [_c('v-btn', {
    attrs: {
      "color": "info",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchDescargarSCTR()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v(" get_app")]), _vm._v("Descarga SCTR")], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), (!_vm.isMovil || _vm.isMovil && _vm.tabActive === 2) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": _vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario' && _vm.ticket.abierto ? '6' : '8'
    }
  }, [_c('v-card', {
    staticClass: "elevation-1"
  }, [_c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll.self",
      value: (_vm.onScroll),
      expression: "onScroll",
      modifiers: {
        "self": true
      }
    }],
    staticClass: "content-time-line",
    class: {
      'is-movil-time-line': _vm.isMovil && _vm.ticket.abierto, 'is-closed-desktop': !_vm.isMovil && !_vm.ticket.abierto, 'is-closed-movil': _vm.isMovil && !_vm.ticket.abierto
    },
    attrs: {
      "id": "scrolling-time-line"
    }
  }, [(_vm.fechaUltimaActividad) ? _c('v-chip', {
    staticClass: "animated fadeInDown faster count",
    class: !_vm.isMovil ? 'left-45' : '',
    attrs: {
      "color": "primary"
    }
  }, [_c('small', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm.fechaUltimaActividad))])]) : _vm._e(), (_vm.ticket.numero) ? _c('time-line-actividades', {
    ref: "activity",
    attrs: {
      "numero": _vm.ticket.numero
    },
    on: {
      "updated": _vm.obtenerFechaUltimaActividad
    }
  }) : _vm._e(), (_vm.ticket.numero) ? _c('div', {
    staticClass: "floating"
  }, [(_vm.scrollInvoked > 1000) ? _c('v-btn', {
    staticClass: "mr-2 animated fadeInUp faster",
    attrs: {
      "small": "small",
      "fab": "fab",
      "color": "ligth"
    },
    on: {
      "click": function($event) {
        return _vm.scrollToTop()
      }
    }
  }, [_c('v-icon', [_vm._v(" keyboard_arrow_up")])], 1) : _vm._e(), _c('v-menu', {
    attrs: {
      "transition": "slide-x-transition",
      "bottom": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "animated fadeInUp faster",
          attrs: {
            "small": "small",
            "fab": "fab",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v(" more_vert")])], 1)]
      }
    }], null, false, 819448673)
  }, [_c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$refs.activity.fetchActividades(true)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Actualizar listado de actividades")])], 1), ((_vm.perfil === 'dispatcher' || _vm.perfil === 'recepcion') && _vm.ticket.tipoticket === 'garantia') ? _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.isModalAsignacionZona = true
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Delimitacion de zona garantia")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1), (_vm.ticket.abierto && !_vm.isLoadingGetUser) ? _c('enviar-mensaje-para-actividad', {
    ref: "enviarMensaje",
    attrs: {
      "numero": _vm.numero,
      "numero-telefono-cliente": _vm.cliente.telefono ? +_vm.cliente.telefono : 0,
      "agente": _vm.usuarioSeleccionado,
      "disabled": _vm.perfil === 'supervisor'
    },
    on: {
      "send": _vm.fetchInsertarActividad,
      "update-time-line": function($event) {
        return _vm.$refs.activity.fetchActividades()
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), ((!_vm.isMovil && _vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario' && _vm.ticket.abierto) || (_vm.isMovil && _vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario' && _vm.ticket.abierto && _vm.tabActive === 3)) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [(_vm.ticket.numero && !_vm.ticket.numeroInformeTecnico && _vm.perfil !== 'usuario-contrato' && _vm.ticket.abierto) ? _c('div', {
    staticClass: "flex-1 mb-3"
  }, [_c('v-btn', {
    staticClass: "width-full",
    attrs: {
      "color": "primary",
      "small": !_vm.isMovil,
      "disabled": _vm.perfil === 'supervisor'
    },
    on: {
      "click": function($event) {
        return _vm.openModalIntegracion(_vm.ticket.tipoticket === 'garantia' ? 18 : 2)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v(" link")]), _vm._v(_vm._s(_vm.ticket.tipoticket === 'garantia' ? 'Recepción' : 'Integrar'))], 1)], 1) : _vm._e(), (_vm.ticket.tipoticket === 'garantia' && _vm.ticket.numero && !_vm.ticket.numeroInformeTecnico && _vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario-contrato' && _vm.ticket.abierto) ? _c('div', {
    staticClass: "flex-1 ml-2 mb-3"
  }, [_c('v-btn', {
    staticClass: "width-full",
    attrs: {
      "color": "primary",
      "small": !_vm.isMovil,
      "disabled": _vm.perfil === 'supervisor'
    },
    on: {
      "click": function($event) {
        return _vm.openModalIntegracion(33)
      }
    }
  }, [_vm._v("Soporte linea")])], 1) : _vm._e()]), (_vm.ticket.tipoticket === 'garantia' && !_vm.ticket.idCita && _vm.ordenDelEstadodelTicket && _vm.ordenDelEstadodelTicket < _vm.ordenEstadoIngresadoTaller) ? _c('div', {
    staticClass: "flex-1 mb-3"
  }, [_c('v-btn', {
    staticClass: "width-full",
    attrs: {
      "color": "info",
      "small": !_vm.isMovil,
      "disabled": _vm.perfil === 'supervisor'
    },
    on: {
      "click": function($event) {
        _vm.isModalEditarCita = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v(" date_range")]), _vm._v("Programar una cita")], 1)], 1) : _vm._e(), _c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.panel2),
      callback: function($$v) {
        _vm.panel2 = $$v
      },
      expression: "panel2"
    }
  }, [_c('v-expansion-panel', {
    key: "usuarios"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("group")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Agente en atención")])], 1)])], 1), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "box-agentes elevation-0",
    attrs: {
      "disabled": _vm.perfil === 'supervisor'
    }
  }, [_c('usuario-seleccionar', {
    attrs: {
      "username": _vm.usuarioSeleccionado,
      "perfiles": ['dispatcher', 'recepcion'],
      "modo-lista": "modo-lista"
    },
    on: {
      "user-selected": _vm.obtenerUsuarioSeleccionado
    }
  })], 1)], 1)], 1), (_vm.ticketsRelacionados.length) ? _c('v-expansion-panel', {
    key: "tickets_relacionados"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("style")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Tickets relacionados")])], 1)])], 1), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "width": "520"
    }
  }, _vm._l((_vm.ticketsRelacionados), function(tk, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex"
    }, [_c('ticket-summary-info', {
      key: tk.numero,
      staticClass: "animated fadeInUp faster",
      attrs: {
        "ticket": tk,
        "is-chart": true,
        "show-numero-informe": true
      },
      on: {
        "goTo": _vm.goTo
      }
    })], 1)
  }), 0)], 1)], 1) : _vm._e(), _c('v-expansion-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ticket.tipoticket === 'garantia' && _vm.ticket.estado <= 2),
      expression: "ticket.tipoticket === 'garantia' && ticket.estado <= 2"
    }],
    key: "zona",
    staticClass: "animated slideInRight faster"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("cancel")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Programar autoanulación por inactividad")])], 1)])], 1), _c('v-expansion-panel-content', [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar-two-line"
    }
  }) : _c('v-select', {
    attrs: {
      "dense": "dense",
      "items": Array.from({
        length: 20
      }, function (_, i) { return i + 1; }),
      "label": ("Anulacion automaticamente en " + (_vm.ticket.diasParaAutoAnulacion ? _vm.ticket.diasParaAutoAnulacion : '?') + " dias"),
      "persistent-hint": "",
      "disabled": _vm.isLoadingChangeDiasAutoAnulacion || _vm.perfil === 'supervisor',
      "hide-details": "hide-details"
    },
    on: {
      "change": _vm.fetchActualizaDiasAutoAnulacion
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('small', {
          staticClass: "font-weight-700"
        }, [_vm._v(_vm._s(data.item) + " " + _vm._s(data.item > 1 ? 'días' : 'día'))])]
      }
    }], null, false, 905677095),
    model: {
      value: (_vm.ticket.diasParaAutoAnulacion),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "diasParaAutoAnulacion", $$v)
      },
      expression: "ticket.diasParaAutoAnulacion"
    }
  }), _c('v-alert', {
    staticClass: "mt-3 mb-0",
    attrs: {
      "text": "",
      "type": "info",
      "dense": "dense"
    }
  }, [_c('small', {
    staticClass: "font-size-11 mt-2"
  }, [_c('span', [_vm._v("El ticket se anulará automaticamente")]), _c('span', [_vm._v("   si permanece en estado")]), _c('span', {
    staticClass: "info--text font-weight-700"
  }, [_vm._v("   \"Registrado\" o \"Revisado por agente\"")]), _c('span', [_vm._v("  y no hay actividad en los proximos " + _vm._s(_vm.ticket.diasParaAutoAnulacion) + " dias")])])]), _c('small', {
    staticClass: "font-weight-700"
  }, [_vm._v("Fecha autoanulación : " + _vm._s(_vm.fechaProbableAnulacionAutomatica))])], 1)], 1), _c('v-expansion-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ticket.tipoticket === 'garantia' && _vm.perfil !== 'usuario'),
      expression: "ticket.tipoticket === 'garantia' && perfil !== 'usuario'"
    }],
    key: "responsable",
    staticClass: "animated slideInRight faster"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("person")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Responsable de la garantia")])], 1)])], 1), _c('v-expansion-panel-content', [(_vm.ticket.tipoticket === 'garantia') ? _c('div', {
    staticClass: "flex-1"
  }, [_c('v-select', {
    attrs: {
      "dense": "dense",
      "items": _vm.responsablesGarantia,
      "label": "Responsable garantia",
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.ticket.responsableGarantia),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "responsableGarantia", $$v)
      },
      expression: "ticket.responsableGarantia"
    }
  })], 1) : _vm._e(), (_vm.ticket.tipoticket === 'garantia' && _vm.ticket.responsableGarantia === 'marca') ? _c('div', {
    staticClass: "flex-1"
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Numero de nota de credito "
    },
    model: {
      value: (_vm.ticket.numeroNotaCreditoGarantia),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "numeroNotaCreditoGarantia", $$v)
      },
      expression: "ticket.numeroNotaCreditoGarantia"
    }
  })], 1) : _vm._e(), (_vm.ticket.tipoticket === 'garantia') ? _c('div', {
    staticClass: "flex-1 d-flex mb-3",
    class: _vm.isMovil && 'fd-column'
  }, [_c('v-btn', {
    staticClass: "flex-1 me-2",
    attrs: {
      "small": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.fecthGuardarDatosResponsableGarantia()
      }
    }
  }, [_c('v-icon', [_vm._v("save")]), _c('small', [_vm._v("Guardar cambios")])], 1)], 1) : _vm._e(), (_vm.ticket.tipoticket === 'garantia') ? _c('div', {
    staticClass: "flex-1 d-flex",
    class: _vm.isMovil && 'fd-column'
  }, [(_vm.ticket.urlDocumentoSustentoGarantia) ? _c('v-btn', {
    staticClass: "flex-1 me-2",
    attrs: {
      "small": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.goToFileSustento()
      }
    }
  }, [_c('v-icon', [_vm._v("link")]), _c('small', [_vm._v("Ver sustento")])], 1) : _vm._e(), (_vm.ticket.responsableGarantia !== 'ninguno') ? _c('v-btn', {
    staticClass: "flex-1",
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isUploadFiles = true
      }
    }
  }, [_c('v-icon', [_vm._v("attach_file")]), _c('small', [_vm._v("Adjuntar sustento")])], 1) : _vm._e()], 1) : _vm._e()])], 1), _c('v-expansion-panel', {
    key: "ticket"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("linear_scale")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Seguimiento de etapas")])], 1)])], 1), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "disabled": _vm.perfil === 'supervisor'
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap"
  }, [_c('div', {
    staticClass: "flex-1 mx-1"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mb-3",
          attrs: {
            "color": "primary",
            "small": !_vm.isMovil,
            "block": "block"
          },
          on: {
            "click": function($event) {
              return _vm.fetchVerificarfechasCambioEstado()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          staticClass: "mr-1"
        }, [_vm._v(" history_toggle_off")]), _vm._v("Hist. estados")], 1)]
      }
    }], null, false, 87533802),
    model: {
      value: (_vm.showPopoverFechasEstado),
      callback: function($$v) {
        _vm.showPopoverFechasEstado = $$v
      },
      expression: "showPopoverFechasEstado"
    }
  }, [_c('v-card', {
    staticClass: "overflow-y-auto",
    attrs: {
      "width": "380",
      "max-height": "500"
    }
  }, _vm._l((_vm.fechasCambioEstado), function(f, index) {
    return _c('v-list', {
      key: index,
      staticClass: "py-0",
      attrs: {
        "dense": "dense"
      }
    }, [_c('v-list-item', [_c('v-list-item-content', {
      staticClass: "py-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-size-12 font-weight-700"
    }, [_c('div', {
      staticClass: "d-flex fd-column"
    }, [_c('div', {
      staticClass: "flex-1"
    }, [_c('span', [_c('v-icon', {
      attrs: {
        "size": "13",
        "color": "success"
      }
    }, [_vm._v("east")]), _c('span', {
      staticClass: "mx-2"
    }, [_vm._v(_vm._s(f.nuevo))])], 1)]), _c('div', {
      staticClass: "flex-1"
    }, [_c('span', [_c('v-icon', {
      attrs: {
        "size": "13",
        "color": "error"
      }
    }, [_vm._v("west")]), _c('span', {
      staticClass: "mx-2"
    }, [_vm._v(_vm._s(f.anterior))])], 1)])])]), _c('v-list-item-subtitle', {
      staticClass: "font-size-11"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('span', [_vm._v(_vm._s(f.now) + " - " + _vm._s(f.fecha))]), _c('v-spacer'), _c('span', [_vm._v(_vm._s(f.usuario))])], 1)])], 1)], 1)], 1)
  }), 1)], 1)], 1), _c('div', {
    staticClass: "flex-1 mx-1"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mb-3",
          attrs: {
            "color": "primary",
            "small": !_vm.isMovil,
            "block": "block"
          },
          on: {
            "click": function($event) {
              return _vm.fetchVerificarfechasCambioEtapa()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          staticClass: "mr-1"
        }, [_vm._v(" history_toggle_off")]), _vm._v("Hist. etapas")], 1)]
      }
    }], null, false, 3291730314),
    model: {
      value: (_vm.showPopoverFechasEtapa),
      callback: function($$v) {
        _vm.showPopoverFechasEtapa = $$v
      },
      expression: "showPopoverFechasEtapa"
    }
  }, [_c('v-card', {
    staticClass: "overflow-y-auto",
    attrs: {
      "width": "380",
      "max-height": "500"
    }
  }, _vm._l((_vm.fechasCambioEtapas), function(f, index) {
    return _c('v-list', {
      key: index,
      staticClass: "py-0",
      attrs: {
        "dense": "dense"
      }
    }, [_c('v-list-item', [_c('v-list-item-content', {
      staticClass: "py-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-size-12 font-weight-700"
    }, [_c('div', {
      staticClass: "d-flex fd-column"
    }, [_c('div', {
      staticClass: "flex-1"
    }, [_c('span', [_c('v-icon', {
      attrs: {
        "size": "13",
        "color": "success"
      }
    }, [_vm._v("east")]), _c('span', {
      staticClass: "mx-2"
    }, [_vm._v(_vm._s(f.nuevo))])], 1)]), _c('div', {
      staticClass: "flex-1"
    }, [_c('span', [_c('v-icon', {
      attrs: {
        "size": "13",
        "color": "error"
      }
    }, [_vm._v("west")]), _c('span', {
      staticClass: "mx-2"
    }, [_vm._v(_vm._s(f.anterior))])], 1)])])]), _c('v-list-item-subtitle', {
      staticClass: "font-size-11"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('span', [_vm._v(_vm._s(f.now) + " - " + _vm._s(f.fecha))]), _c('v-spacer'), _c('span', [_vm._v(_vm._s(f.usuario))])], 1)])], 1)], 1)], 1)
  }), 1)], 1)], 1)]), _c('v-stepper', {
    staticClass: "elevation-0 pb-0",
    attrs: {
      "vertical": "",
      "dense": "dense",
      "disabled": _vm.isLoadingEtapas
    },
    model: {
      value: (_vm.indexEtapaSeleccionada),
      callback: function($$v) {
        _vm.indexEtapaSeleccionada = $$v
      },
      expression: "indexEtapaSeleccionada"
    }
  }, [_vm._l((_vm.listaEtapas), function(n, index) {
    return [_c('v-stepper-step', {
      key: ((n.id) + "-step"),
      staticClass: "cursor-step pt-2 pb-1 pl-1",
      class: n.id < _vm.ticket.etapaEstado && 'pointer-events',
      attrs: {
        "dense": "dense",
        "step": n.id,
        "complete": _vm.indexEtapaSeleccionada > n.id,
        "color": _vm.indexEtapaSeleccionada > n.id ? 'success' : 'primary'
      },
      nativeOn: {
        "click": function($event) {
          _vm.indexEtapaSeleccionada = n.id
        }
      }
    }, [_c('small', {
      staticClass: "font-weight-700"
    }, [_vm._v(_vm._s(n.descripcion))]), (n.id < _vm.ticket.etapaEstado) ? _c('small', {
      staticClass: "font-weight-700 font-size-10 success--text"
    }, [_vm._v("etapa cerrada")]) : _vm._e()]), _c('v-stepper-content', {
      key: ((n.id) + "-step-content"),
      staticClass: "pa-3 ml-4",
      attrs: {
        "step": n.id
      }
    }, [(_vm.renderComponentEstados) ? _c('estados-ticket', {
      attrs: {
        "tipo": _vm.ticket.tipoticket,
        "codigo": _vm.ticket.estado,
        "etapa": n.id
      },
      on: {
        "selected": _vm.obtenerEstado
      }
    }) : _vm._e()], 1)]
  })], 2), (_vm.ticket.tipoticket === 'garantia') ? _c('div', {
    staticClass: "mt-8"
  }, [_c('v-select', {
    attrs: {
      "items": ['propio', 'tercerizado'],
      "label": "¿A que taller ingreso el equipo?",
      "dense": "",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.fetchActualizarTipoTallerIngresado()
      }
    },
    model: {
      value: (_vm.ticket.tipoTallerIngresado),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "tipoTallerIngresado", $$v)
      },
      expression: "ticket.tipoTallerIngresado"
    }
  })], 1) : _vm._e(), (_vm.ticket.tipoticket === 'garantia') ? _c('div', {
    staticClass: "mt-6"
  }, [_c('v-switch', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "dense",
      "label": "¿Es servicio cobrable?",
      "value": 1,
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.ticket.esCobrable),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "esCobrable", $$v)
      },
      expression: "ticket.esCobrable"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), (_vm.ticket.tipoticket === 'garantia') ? _c('v-expansion-panel', {
    key: "equipo_cambiar"
  }, [_c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("print")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Actualización de datos de equipo")])], 1)])], 1), _c('v-expansion-panel-content', [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar-two-line"
    }
  }) : _c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "disabled": _vm.perfil === 'supervisor'
    }
  }, [(_vm.ticket.tipoticket === 'garantia' && _vm.ticket.comproAqui) ? _c('v-alert', {
    staticClass: "mb-6",
    attrs: {
      "text": "",
      "type": _vm.ticket.sigueEnGarantia ? 'success' : 'error',
      "dense": "dense"
    }
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Al registrarse el ticket el usuario indico que el equipo " + _vm._s(_vm.ticket.sigueEnGarantia ? 'todavia se encuentra ' : 'ya no se encuentra ') + " en garantía")])]) : _vm._e(), (_vm.ticket.tipoticket === 'garantia') ? _c('div', {
    staticClass: "flex-1"
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Ingrese la serie del equipo "
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-btn', {
          staticClass: "mb-2",
          attrs: {
            "x-small": "x-small",
            "fab": "fab",
            "color": "info"
          },
          on: {
            "click": function($event) {
              _vm.showModalDataSerie = true
            }
          }
        }, [_c('v-icon', [_vm._v(" visibility")])], 1)]
      },
      proxy: true
    }], null, false, 254630055),
    model: {
      value: (_vm.ticket.serie),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "serie", $$v)
      },
      expression: "ticket.serie"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex",
    class: _vm.isMovil && 'fd-column'
  }, [(_vm.ticket.tipoticket === 'garantia') ? _c('div', {
    staticClass: "flex-1"
  }, [_c('v-select', {
    attrs: {
      "dense": "dense",
      "items": _vm.marcas,
      "label": "Seleccionar marca",
      "item-text": "descripcion",
      "item-value": "descripcion",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.ticket.marca),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "marca", $$v)
      },
      expression: "ticket.marca"
    }
  })], 1) : _vm._e(), (_vm.ticket.tipoticket === 'garantia') ? _c('div', {
    staticClass: "flex-1",
    class: !_vm.isMovil && 'px-6'
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Ingrese el modelo del equipo "
    },
    model: {
      value: (_vm.ticket.modelo),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "modelo", $$v)
      },
      expression: "ticket.modelo"
    }
  })], 1) : _vm._e()])], 1)], 1), _c('v-expansion-panel-header', {
    staticClass: "pa-2"
  }, [(!_vm.ticket.numero) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }) : _c('strong', {
    staticClass: "font-weight-700"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-icon', {
    staticClass: "mr-2 primary-color"
  }, [_vm._v("style")]), _c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Permisos para documentos de tecnico")])], 1)])], 1), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "width": "520"
    }
  }, _vm._l((_vm.tiposDocumentos), function(item, i) {
    return _c('div', {
      staticClass: "d-flex ai-center"
    }, [_c('v-checkbox', {
      staticClass: "ma-0",
      attrs: {
        "name": item.code,
        "id": item.code,
        "color": "primary",
        "hide-details": "hide-details"
      },
      model: {
        value: (item.active),
        callback: function($$v) {
          _vm.$set(item, "active", $$v)
        },
        expression: "item.active"
      }
    }), _c('label', {
      staticClass: "font-size-11",
      class: {
        '!primary--text font-weight-700': item.active
      },
      attrs: {
        "for": item.code
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 0)], 1)], 1) : _vm._e(), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "block": "block",
      "color": "success",
      "disabled": !_vm.ticket.abierto || _vm.perfil === 'supervisor',
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.openModalAddMessage()
      }
    }
  }, [_vm._v("Confirmar cambios")])], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fd8c3f4","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_detalle_ticket.vue
// module id = 476
// module chunks = 1